import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useState } from '@/composable/useState';
import { i18n, languageFileMap } from '@/core/lib/i18n';
import { RecommendationApi } from '@/core/lib/recommendationApi';
import type { IHotlink } from '@/interface/IHotlink';
import type { RogueModelsHotLink } from '@/interface/rogue';

export const useHotLinkStore = defineStore('HotLink', () => {
    const [rawHotlinks, setRawHotlinks] = useState<RogueModelsHotLink[]>([]);

    let loading: Promise<void> | null = null;

    async function loadHotlinks() {
        try {
            setRawHotlinks(await RecommendationApi.getHotlinks());
        } catch (err) {
            console.error('[hotLinkStore] failed to load hotlinks', err);
            setRawHotlinks([]);
        }
    }

    function initHotLink() {
        loading ??= loadHotlinks();
        return loading;
    }

    /** Settles once the hotlinks request has finished (or failed); starts the request if it was never started. */
    function waitUntilLoaded() {
        return loading ?? initHotLink();
    }

    const hotlinks = computed<IHotlink[]>(() => {
        const localeFile = languageFileMap.find(lang => lang.name === i18n.locale.value)?.file ?? 'en';
        return rawHotlinks.value.map(raw => ({
            id: raw.id ?? '',
            leagueNames: raw.leagueNames ?? [],
            sportType: raw.sportType,
            route: raw.route ?? '',
            title: raw.titles?.[localeFile] ?? raw.titles?.en ?? '',
            titleEn: raw.titles?.en ?? '',
        }));
    });

    return {
        hotlinks,
        initHotLink,
        waitUntilLoaded,
    };
});
